import {
  ActivatedRouteSnapshot,
  CanActivate,
  CanActivateChild,
  Route,
  Router,
  RouterStateSnapshot,
  UrlSegment,
  UrlTree
} from '@angular/router';

import { Injectable } from '@angular/core';
import { PermissionsService } from '@app/core/permissions/permissions.service';
import { Observable, of } from 'rxjs';
import { map, take } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class PermissionsGuard implements CanActivate, CanActivateChild {
  constructor(private permissionsService: PermissionsService, private router: Router) {}

  /**
   * determine if the user can Activate the children of this module
   */
  canActivateChild(
    childRoute: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return this.checkPermission(childRoute);
  }

  /**
   * determine if the user can Activate this module
   */
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return this.checkPermission(route);
  }

  /**
   * generic check Permissions function for a permissions key
   * @param route: route of module to parse from routing and get the permissionsKeys from data key
   */
  checkPermission(route: ActivatedRouteSnapshot | Route): Observable<boolean> {
    if (route.data.permissionsKeys && route.data.permissionsKeys.length) {
      return this.permissionsService
        .permissionsRequest({
          getPermissions: () => {
            return route.data.permissionsKeys.every((permissionKey: { module?: string; key?: string }) => {
              return this.permissionsService.getPermissions(permissionKey.key);
            });
          }
        })
        .pipe(
          take(1),
          map(havePermission => {
            if (!havePermission) {
              this.router.navigate(['/401'], { replaceUrl: false, skipLocationChange: true });
              return false;
            }
            return havePermission;
          })
        );
    }
    // No permissions required, allow access
    return of(true).pipe(take(1));
  }
}
